import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const getMonthWeekInfo = (date: Dayjs) => {
  const thisWeekMonday =
    date.day() === 0
      ? date.startOf('week').subtract(6, 'day')
      : date.startOf('week').add(1, 'day');
  const thisWeekThursday = thisWeekMonday.add(3, 'day');
  const thisWeekSunday = thisWeekMonday.add(6, 'day');

  const thisYear = thisWeekThursday.year();
  const thisMonth = thisWeekThursday.month();
  const thisMonthFirstDay = dayjs().year(thisYear).month(thisMonth).date(1);

  const thisMonthFirstMonday = isMondayToThursday(thisMonthFirstDay)
    ? thisMonthFirstDay.startOf('week').add(1, 'day')
    : thisMonthFirstDay.add(1, 'week').startOf('week').add(1, 'day');
  const weekDiff = date.diff(thisMonthFirstMonday, 'week');

  return {
    year: thisYear,
    month: thisMonth + 1,
    thisMonthWeekNum: weekDiff + 1,

    thisWeekMonday,
    thisWeekSunday,
  };
};

export const isMondayToThursday = (date: Dayjs) => {
  return date.day() >= 1 && date.day() <= 4;
};
